import { WidgetConfig } from 'components/Dashboard/types';
import { KPIsWidgetEnum } from './utils';
import TBWidget from './widgets/TBWidget';
import OBDNotUsedWidget from './widgets/OBDNotUsedWidget';
import CancellationsWidget from './widgets/CancellationsWidget';
import DeviationJobsWidget from './widgets/DeviationJobsWidget';
import VehicleFaultsWidget from './widgets/VehicleFaultsWidget';
import ETAAccuracyWidget from './widgets/ETAAccuracyWidget';
import AssignmentsPlanningWidget from './widgets/AssignmentsPlanningWidget';
import UniqueAssigneesWidget from './widgets/UniqueAssigneesWidget';
import CasesBySupplierWidget from './widgets/CasesBySupplierWidget';
import DeliveryConditionWidget from './widgets/DeliveryConditionWidget';
import AverageDrivingDistanceWidget from './widgets/AverageDrivingDistanceWidget';
import HotelNightsWidget from './widgets/operations/HotelNightsWidget';
import FieldTestersWithoutJobsWidget from './widgets/operations/FieldTestersWithoutJobsWidget';
import DeclinedJobsWidget from './widgets/operations/DeclinedJobsWidget';
import FieldTesterTenureWidget from './widgets/operations/FieldTesterTenureWidget';
import CentralStationOvernightsWidget from './widgets/operations/CentralStationOvernightsWidget';
import DeniedAssignmentRequestsWidget from './widgets/operations/DeniedAssignmentRequestsWidget';
import ReturnToLogisticsWidget from './widgets/operations/ReturnToLogisticsWidget';
import SingleLegJobsWidget from './widgets/operations/SingleLegJobsWidget';
import WorkedTimePerFieldTesterDayWidget from './widgets/operations/WorkedTimePerFieldTesterDayWidget';
import TB1ByCaseTypeAndCountyWidget from './widgets/TB1ByCaseTypeAndCountyWidget';
import { memo } from 'react';
import DashboardWidgetsWrapper from 'components/Dashboard/WidgetWrapper';
import { useDashboardControls } from 'contexts/Dashboard/useDashboardControls';

const widgetsConfig: WidgetConfig<KPIsWidgetEnum>[] = [
  {
    widgetType: KPIsWidgetEnum.TB,
    component: memo(TBWidget),
  },
  {
    widgetType: KPIsWidgetEnum.OBDNotUsed,
    component: memo(OBDNotUsedWidget),
  },
  {
    widgetType: KPIsWidgetEnum.Cancellations,
    component: memo(CancellationsWidget),
  },
  {
    widgetType: KPIsWidgetEnum.DeviationJobs,
    component: memo(DeviationJobsWidget),
  },
  {
    widgetType: KPIsWidgetEnum.VehicleFaults,
    component: memo(VehicleFaultsWidget),
  },
  {
    widgetType: KPIsWidgetEnum.ETAAccuracy,
    component: memo(ETAAccuracyWidget),
  },
  {
    widgetType: KPIsWidgetEnum.AssignmentsPlanning,
    component: memo(AssignmentsPlanningWidget),
  },
  {
    widgetType: KPIsWidgetEnum.UniqueAssignees,
    component: memo(UniqueAssigneesWidget),
  },
  {
    widgetType: KPIsWidgetEnum.CasesBySupplier,
    component: memo(CasesBySupplierWidget),
  },
  {
    widgetType: KPIsWidgetEnum.DeliveryCondition,
    component: memo(DeliveryConditionWidget),
  },
  {
    widgetType: KPIsWidgetEnum.AverageDrivingDistance,
    component: memo(AverageDrivingDistanceWidget),
  },
  {
    widgetType: KPIsWidgetEnum.TB1ByCaseTypeAndCounty,
    component: memo(TB1ByCaseTypeAndCountyWidget),
  },
  {
    widgetType: KPIsWidgetEnum.ReturnToLogistics,
    component: memo(ReturnToLogisticsWidget),
  },
  {
    widgetType: KPIsWidgetEnum.SingleLegJobs,
    component: memo(SingleLegJobsWidget),
  },
  {
    widgetType: KPIsWidgetEnum.WorkedTimePerFieldTesterDay,
    component: memo(WorkedTimePerFieldTesterDayWidget),
  },
  {
    widgetType: KPIsWidgetEnum.HotelNights,
    component: memo(HotelNightsWidget),
  },
  {
    widgetType: KPIsWidgetEnum.FieldTestersWithoutJobs,
    component: memo(FieldTestersWithoutJobsWidget),
  },
  {
    widgetType: KPIsWidgetEnum.DeclinedJobs,
    component: memo(DeclinedJobsWidget),
  },
  {
    widgetType: KPIsWidgetEnum.FieldTesterTenure,
    component: memo(FieldTesterTenureWidget),
  },
  {
    widgetType: KPIsWidgetEnum.CentralStationOvernights,
    component: memo(CentralStationOvernightsWidget),
  },
  {
    widgetType: KPIsWidgetEnum.DeniedAssignmentRequests,
    component: memo(DeniedAssignmentRequestsWidget),
  },
];

const DashboardKPIs = () => {
  const {
    dashboardState: { widgets },
  } = useDashboardControls();

  const getIsActive = (widgetType: KPIsWidgetEnum) => {
    return widgets.some(
      (w) => w.identifier === widgetType && w.active === true
    );
  };

  return (
    <DashboardWidgetsWrapper>
      {widgetsConfig.map(
        ({ widgetType, component: Component }) =>
          getIsActive(widgetType) && <Component key={widgetType} />
      )}
    </DashboardWidgetsWrapper>
  );
};

export default DashboardKPIs;
